import { useState } from "react";
import { DateRangePicker, createStaticRanges } from "react-date-range";
import { addDays, startOfWeek, endOfWeek } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const MyDateRangePicker = ({ onChange, value }) => {
  const [range, setRange] = useState(
    value || [
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ]
  );

  const customStaticRanges = createStaticRanges([
    {
      label: "Today",
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
      }),
    },
    {
      label: "Yesterday",
      range: () => ({
        startDate: addDays(new Date(), -1),
        endDate: addDays(new Date(), -1),
      }),
    },
    {
      label: "This Week",
      range: () => ({
        startDate: startOfWeek(new Date()),
        endDate: endOfWeek(new Date()),
      }),
    },
  ]);

  const handleChange = (item) => {
    setRange([item.selection]);
    onChange?.(item.selection); 
  };

  return (
    <DateRangePicker
      onChange={handleChange}
      ranges={range}
      staticRanges={customStaticRanges}
      showSelectionPreview
      moveRangeOnFirstSelection={false}
      months={1}
      direction="horizontal"
    />
  );
};

export default MyDateRangePicker;
